<script lang="ts">
    import { mdiHeartOutline } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"

    export let productId: string
</script>

<button>
    <Icon
        path="{mdiHeartOutline}"
        size="{24}px"
    />
</button>

<style lang="less">
    button {
        position: relative;
        z-index: 100;
        color: var(--text-invers-100);
    }
</style>
